import {
  FETCH_SWITCHORGANIZATIONS_REQUEST,
  FETCH_SWITCHORGANIZATIONS_SUCCESS,
  FETCH_SWITCHORGANIZATIONS_FAILURE,
} from '../actions/switchOrganizationAction';

const initialState = {
  switchOrganizations: [],
  accessToken: null,
  loading: false,
  error: null,
};
const switchOrganizationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SWITCHORGANIZATIONS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_SWITCHORGANIZATIONS_SUCCESS:
      console.log('Switched Org Data:', action.payload);
      return { ...state, loading: false, switchOrganizations: action.payload };
    case FETCH_SWITCHORGANIZATIONS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
export default switchOrganizationsReducer;
